<div
  class="lum-c-cost-layer-changes-ag-cell-transaction"
  *ngIf="change?.transactionType; else whenNoTransactionType"
>
  <ng-container [ngSwitch]="change.transactionType">
    <ng-container *ngSwitchCase="ECostLayerChangeTransactionType.PICKLIST">
      <a
        *ngIf="change.transaction; else whenNoTransactionData"
        [routerLink]="['/shipping/picklists', change.transaction.id]"
        >Picklist #{{ change.transaction.id }}</a
      >
    </ng-container>
    <ng-container *ngSwitchCase="ECostLayerChangeTransactionType.RECEIPT">
      <button
        *ngIf="change.transaction; else whenNoTransactionData"
        type="button"
        class="linkish text-left"
        (click)="handleClickReceipt($event)"
      >
        Receipt #{{ change.transaction.id }}
        <small>{{ change.transaction.number }}</small>
      </button>
    </ng-container>
    <ng-container *ngSwitchCase="ECostLayerChangeTransactionType.SALES_ORDER">
      <a
        *ngIf="change.transaction; else whenNoTransactionData"
        [routerLink]="['/shipping/posted-orders', change.transaction.id]"
        >Sales Order {{ change.transaction.number }}</a
      >
    </ng-container>
    <ng-container *ngSwitchDefault>
      {{
        HumanTitleByTransactionType[change.transactionType] ??
          change.transactionType
      }}
      <ng-container *ngIf="change.transaction">
        #{{ change.transaction.id }}
        <small
          *ngIf="
            change.transaction.number &&
            change.transaction.number !== change.transaction.id
          "
          >{{ change.transaction.number }}</small
        >
      </ng-container>
    </ng-container>
    <ng-template #whenNoTransactionData>
      Unidentified
      {{ HumanTitleByTransactionType[change.transactionType] ?? 'Transaction' }}
      <ng-container
        *ngTemplateOutlet="showableData; context: { type: 'noTransaction' }"
      ></ng-container>
    </ng-template>
  </ng-container>
</div>
<ng-template #whenNoTransactionType>
  <ng-container *ngIf="change; else whenNoData">
    Unknown Transaction
    <ng-container
      *ngTemplateOutlet="showableData; context: { type: 'unknown' }"
    ></ng-container>
  </ng-container>
  <ng-template #whenNoData>
    <ng-container *ngIf="!didInit; else whenNoDataAndInitComplete">
      Loading...
    </ng-container>
    <ng-template #whenNoDataAndInitComplete> ERROR </ng-template>
  </ng-template>
</ng-template>

<ng-template #showableData let-type="type">
  <details (toggle)="handleToggleData($event, type)">
    <summary class="text-muted"
      ><small
        >{{ showingTransactionDetails ? 'Hide' : 'Show' }} Data</small
      ></summary
    >
    <pre class="lum-pre">{{ change | json }}</pre>
  </details>
</ng-template>
